import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ────────────────────────────────────────────────────────────────────────────
// DOM patch defensiv pentru compatibilitate cu Google Translate.
// Google Translate înlocuiește text nodes cu noduri proprii, ceea ce strică
// reconcilierea DOM-ului React → eroare „removeChild on Node failed: The node
// to be removed is not a child of this node". Aplicăm un fallback sigur care
// nu aruncă, ci ignoră operațiile pe noduri orfane (cum recomandă Google +
// echipa React în issue-uri publice).
// Sursa: https://github.com/facebook/react/issues/11538
// ────────────────────────────────────────────────────────────────────────────
if (typeof Node === "function" && Node.prototype) {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn("[DOM-patch] Skipping removeChild on detached node (likely Google Translate).");
      }
      return child;
    }
    return origRemoveChild.apply(this, arguments);
  };
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn("[DOM-patch] Skipping insertBefore on detached reference (likely Google Translate).");
      }
      return this.appendChild(newNode);
    }
    return origInsertBefore.apply(this, arguments);
  };
}

// Register PWA service worker (production only)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
